module.exports = __webpack_public_path__ + "nc_static/media/mili.141175b9.png";